// يبني مستند HTML كاملاً ويفتحه في نافذة جديدة (الطباعة الأصلية للمتصفح تُنتج الـ PDF).
import { css } from "./reportTokens";
import { L } from "./reportLabels";
import { buttons, cards, header } from "./reportHeader";
import { table, pageCount } from "./reportTable";
import { explain, footer, warning } from "./reportNotes";
import { shareBar } from "../reports/shareBar";
import { pdfScript } from "../reports/pdfActions";
import { refLine } from "../reports/refLine";
import { openSharedReportWindow } from "../reports/openShared";
import { reportTitle } from "../reports/reportTitle";

export const buildReportHtml = (data, lang = "ar", options = {}, share = null) => {
  const labels = L[lang === "en" ? "en" : "ar"];
  const rtl = lang !== "en";
  const title = share?.title || (options.custom ? labels.titleCustom : labels.titleMany);
  return `<!DOCTYPE html>
<html lang="${rtl ? "ar" : "en"}" dir="${rtl ? "rtl" : "ltr"}">
<head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1"><title>${title}</title><style>${css(Boolean(options.custom))}</style></head>
<body>
${buttons(labels, share, options.pdfUrl)}
${refLine(share, labels.reference)}
${header(data, labels, options)}
${cards(data, labels, options)}
${table(data, labels, options)}
${explain(data, labels)}
${warning(data, labels, options)}
${footer(labels, pageCount(data))}
${shareBar(share?.url, labels.copied)}
${pdfScript(options.pdfUrl, title, labels)}
</body></html>`;
};

export const openReportWindow = (data, lang, options = {}) =>
  openSharedReportWindow({
    title: reportTitle(data, lang, { kind: "salary", custom: options.custom }),
    win: options.win,
    ticket: options.ticket || null,
    pdfUrl: options.pdfUrl || null,
    ticketPromise: options.ticketPromise || null,
    opts: options,
    fileName: `payroll-${data.period_start || ""}`,
    lang,
    meta: {
      company: options.brand?.name,
      branch: data.branch_name || (lang === "en" ? "All branches" : "جميع الفروع"),
      branch_id: data.branch_id || null,
      period: `${data.period_start} → ${data.period_end}`,
    },
    build: (share) => buildReportHtml(data, lang, options, share),
  });
